<template lang="pug">
  .auth__password
    input(
      name="password"
      :type="type"
      :value="password"
      :class="{'error': error }"
      :placeholder="$t('auth.form.password')"
      @input="$emit('input', $event.target.value)")

    .togglePassword(@click="togglePassword")
      van-icon(:name="icon")
</template>

<script>
/**
 * PASSWORD
 *
 * Input tipo password que permite mostrar/ocultar la contraseña mediante un botón
 */
export default {
  props: {
    password: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: 'password',
      icon: 'hide',
    };
  },
  methods: {
    /*
     * Alterna el tipo de input para mostrar el valor de la contraseña
     */
    togglePassword() {
      if (this.type === 'password') {
        this.type = 'text';
        this.icon = 'hide';
      } else {
        this.type = 'password';
        this.icon = 'show';
      }
    },
  },
};
</script>
